export const i18nConditionDeviationPage = {
  tabs: {
    ACTION_ISSUED: 'Aberto',
    COMPLETED: 'Concluído',
    ALL: 'Todos',
  },
  newCd: 'Novo DC',
  action_status: {
    INVESTIGATING: 'Investigando',
    ACTION_ISSUED: 'Ação Emitida',
    COMPLETED: 'Concluído',
    CANCELED: 'Cancelado',
  },
  sap_note_status: {
    'open-critical': 'Aberto crítico',
    'open-non-critical': 'Aberto não crítico',
    closed: 'Fechado',
    offline: 'Não encontrado',
    not_found: 'Não encontrado',
    not_informed: 'Não informado',
  },
  columns: {
    id: 'ID',
    asset: 'Ativo',
    dimension: 'Dimensão',
    deviation_start: 'Inicio Desv. ',
    deviation_end: 'Fim Desv.',
    last_update_date: 'Últ. edição',
    action_status: 'Status da ação',
    condition_evaluation: 'Sever.',
    diagnosis: 'Diagnóstico',
    recommended_action: 'Ação recomendada',
    sap_note: 'Nota',
  },
  notFound: 'Não encontrado',
  status_count_panel: {
    total: { caption: 'DCs' },
    severity: {
      status: {
        title: 'Avaliação da condição',
        4: 'Muito Alta',
        3: 'Alta',
        2: 'Média',
        1: 'Normal',
        modec: {
          5: 'Condição Crítica',
          4: 'Problema Potencial',
          3: 'Condição de Alarme',
          2: 'Não Monitorado',
          1: 'Não Operado',
          0: 'Condição Normal',
        },
      },
    },
    status: {
      total: { title: 'Total', total: 'DCs' },
      action_status: {
        title: 'Status da ação',
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Ação Emitida',
        CANCELLED: 'Cancelado',
        COMPLETED: 'Concluído',
      },
      classification: { title: 'Classificação', Useful: 'Útil', 'Not Useful': 'Não útil' },
    },
  },
  error: {
    noOpenConditionDeviations: 'Não há desvios de condições abertos no momento.',
    noClosedConditionDeviations: 'Não há desvios de condição fechada no período selecionado.',
    noConditionDeviations: 'Não há desvios de condição no período selecionado.',
  },
};
